import { ReactNode, createContext, useContext } from "react";
import { useFilterSubscription } from "./filter-subscription.hook";

const FilterSubscriptionContext = createContext(
  {} as ReturnType<typeof useFilterSubscription>
);
export function useFilterSubscriptionContext() {
  return useContext(FilterSubscriptionContext);
}

interface FilterSubscriptionProviderProps {
  children: ReactNode;
}
export function FilterSubscriptionProvider({
  children,
}: FilterSubscriptionProviderProps) {
  return (
    <FilterSubscriptionContext.Provider value={useFilterSubscription()}>
      {children}
    </FilterSubscriptionContext.Provider>
  );
}